/**
 * Default structure for the wellness_plan_json field in the Participant table
 */

export default {

    defaultPlan: {
        habits: [
            // {
            //     habit: `Do a minimum of a 30 minute brisk walk every day`,
            //     reminder: true,
            // },
        ],
        path: {
            vision: '',
            values: '',
            confidence: '',
        },
        goals: [
            // {
            //     timeframe: '1 week',
            //     goal: 'I will taste two new vegetables by Saturday'
            // },
        ]
    }

}
